import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function ContentSection() {
  return (
    <section id="about" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="lg:w-1/2 w-full">
            <div className="relative overflow-hidden rounded-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20flatlay%20with%20designer%20sneakers%20neutral%20toned%20hoodies%20and%20small%20luxury%20accessories%20aesthetically%20arranged%20on%20warm%20cream%20linen%20texture%20surface%20with%20soft%20natural%20window%20light%20casting%20subtle%20shadows%20clean%20editorial%20composition%20warm%20beige%20and%20sand%20tones%20premium%20lifestyle%20product%20photography&width=800&height=1000&seq=about-fashion-flat-2026&orientation=portrait"
                alt="CSSBuy spreadsheet finds - Premium shopping companion"
                title="CSSBuy Spreadsheet Finds - Premium Shopping Companion"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:w-1/2 w-full">
            <span className="inline-block px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wide mb-5">
              About CSSBuy Sheet
            </span>

            <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-900 leading-tight mb-6">
              Your Ultimate<br />
              Shopping Companion
            </h2>

            <div className="space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              <p>
                The <strong className="text-foreground-900">CSSBuy spreadsheet</strong> has become an essential tool for thousands of savvy shoppers worldwide. Whether you are hunting for the latest sneaker releases, premium streetwear pieces, or hidden luxury gems, having a well-organized <strong className="text-foreground-900">CSS spreadsheet</strong> can save you hours of browsing and help you discover products you would never find on your own.
              </p>
              <p>
                Our <strong className="text-foreground-900">CSSBuy spreadsheet 2026</strong> directory brings together the most comprehensive collection of verified finds — from Nike and Jordan sneakers to Essentials hoodies, Chrome Hearts accessories, and everything in between. Each spreadsheet is regularly updated to ensure you always have access to the freshest drops and best-value items.
              </p>
              <p>
                What sets our directory apart is the level of curation. We do not just list every spreadsheet we come across. Every entry in our <strong className="text-foreground-900">CSSBuy spreadsheet</strong> collection is manually reviewed for quality, accuracy, and relevance. This means you spend less time digging through dead links and more time finding exactly what you want.
              </p>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-between px-6 py-3 rounded-xl bg-foreground-900 text-white font-medium text-sm hover:bg-foreground-800 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                Visit Main Store
                <i className="ri-arrow-right-up-line ml-2"></i>
              </a>
              <Link
                to="/cssbuy-spreadsheet-guide-2026"
                className="inline-flex items-center justify-center px-6 py-3 rounded-xl border border-foreground-200 text-foreground-800 font-medium text-sm hover:bg-foreground-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                Read Full Guide
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}